// TODO: refactor env variables names ( use unified names )
export const environment = {
  production: true,
  version: "0.0.1 (beta)",
  graphql_endpoint: "https://cert-rentalab-graph.fth.dev/graphql",
  url: "https://cert-rentalab-file.fth.dev",
  skip_auth: false,
  REPORT_URL: "https://cert-rentalab-report.fth.dev/download-report",
  routes_api_key: "REPLACE_ME",
  GOOGLE_SCRIPT: "https://maps.googleapis.com/maps/api/js",
  google_api_key: "REPLACE_ME",
  places_key: "REPLACE_ME",

  firebase: {
    apiKey: "REPLACE_ME",
    authDomain: "REPLACE_ME",
    projectId: "REPLACE_ME",
    storageBucket: "REPLACE_ME",
    messagingSenderId: "REPLACE_ME",
    appId: "REPLACE_ME",
    measurementId: "REPLACE_ME",
  },
  VAPIDKEY: "REPLACE_ME",
  RECAPTCHA_SITE_KEY: "REPLACE_ME",
  RECAPTCHA_SECRET_KEY: "REPLACE_ME",
  RECAPTCHA_API_URL: "https://www.google.com/recaptcha/api.js?render=explicit",
  REALTIME_SOCKET_URL: "https://cert-rentalab-realtime.fth.dev",
  CRM_SOCKET_URL: "https://cert-rentalab-crm.fth.dev",
  GEO_SERVICE_URL: "https://cert-rentalab-geo.fth.dev",
  SHOW_SENTRY_REPORT_BUTTON: true,
};
